import {OtherPyroProductsThanClinkerClassificationInputNames, MaterialType} from '@domain/materials'
import {dataTestId} from '@hconnect/uikit'
import {useFormContext} from 'react-hook-form'

import {useMaterialsClassificationMetadata} from '../../../hooks'
import {MaterialFormDefaultValues} from '../../materials-details/ExistingMaterialDetails/hooks'
import {MaterialsGrid} from '../components/MaterialsGrid'
import {MaterialsGridItem} from '../components/MaterialsGridItem'

import {ClassificationAutocomplete} from './inputs/ClassificationAutocomplete'
import {ClassificationTextField} from './inputs/ClassificationTextField'

interface OtherPyroProductsThanClinkerClassificationProps {
  isDisabled: boolean
}

export const OtherPyroProductsThanClinkerClassification: React.FC<
  OtherPyroProductsThanClinkerClassificationProps
> = ({isDisabled}) => {
  const {data: metadata} = useMaterialsClassificationMetadata(
    MaterialType.OtherPyroProductsThanClinker
  )

  useFormContext<MaterialFormDefaultValues>()
  if (!metadata) {
    throw new Error(
      'BUG: classification metadata should be loaded before rendering classification tab'
    )
  }

  return (
    <MaterialsGrid {...dataTestId('OtherPyroProductsThanClinker_classification_form')}>
      <MaterialsGridItem>
        <ClassificationAutocomplete
          materialType={MaterialType.OtherPyroProductsThanClinker}
          inputName={OtherPyroProductsThanClinkerClassificationInputNames.Category}
          metadata={metadata}
          isDisabled={isDisabled}
        />
      </MaterialsGridItem>
      <MaterialsGridItem>
        <ClassificationTextField
          materialType={MaterialType.OtherPyroProductsThanClinker}
          inputName={OtherPyroProductsThanClinkerClassificationInputNames.LegacyId}
          metadata={metadata}
          isDisabled={isDisabled}
        />
      </MaterialsGridItem>
    </MaterialsGrid>
  )
}
